/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnMetricDistrict } from './en-metric-district';
import { EnMetricMeasure } from './en-metric-measure';
import { EnMetricSide } from './en-metric-side';
 /**
 *
 *
 * @export
 * @interface SessionCountRequestDto
 */
export interface SessionCountRequestDto {

    /**
     * @type {string}
     * @memberof SessionCountRequestDto
     */
    from: string;

    /**
     * @type {string}
     * @memberof SessionCountRequestDto
     */
    to?: string;

    /**
     * Filter by anatomical district.
     *
     * @type {EnMetricDistrict}
     * @memberof SessionCountRequestDto
     */
    district?: EnMetricDistrict;

    /**
     * Filter by body side.
     *
     * @type {EnMetricSide}
     * @memberof SessionCountRequestDto
     */
    side?: EnMetricSide;

    /**
     * Filter by measure.
     *
     * @type {EnMetricMeasure}
     * @memberof SessionCountRequestDto
     */
    measure?: EnMetricMeasure;

    /**
     * @type {Array<number>}
     * @memberof SessionCountRequestDto
     */
    eventIds: Array<number>;

    /**
     * @type {number}
     * @memberof SessionCountRequestDto
     */
    assignmentId?: number;

    /**
     * @type {string}
     * @memberof SessionCountRequestDto
     */
    query?: string;
}
